import { ProjectTimelineItem } from './project'

export enum ReportState {
	processed = 'PROCESSED',
	pinned = 'PINNED',
	uploading = 'UPLOADING',
	uploaded = 'UPLOADED',
	failedToProcess = 'FAILED_TO_PROCESS',
}

export interface ConvertedRun {
	id: string
	date: Date
	count?: number
	deltaFromPrevious?: number
	height: number
	state: ConvertedRunState
}

export enum ConvertedRunState {
	successful = 'successful',
	failed = 'failed',
	noProblems = 'noProblems',
	processing = 'processing',
}

export interface TimelineData {
	count: number
	items: ProjectTimelineItem[]
	next?: number | null
	prev?: number | null
}
